import { DatePicker } from 'antd';
import type { Dayjs } from 'dayjs';

import {
  DATE_FORMAT,
  getDateRangeWithEndDateOffset,
  getEndDateManipulatedDateRange,
} from '@/utils/time';

type Props = {
  dateRange: [Dayjs, Dayjs];
  onChange: (range: [Dayjs, Dayjs]) => void;
};

const { RangePicker } = DatePicker;

const SearchDateFilter = (props: Props) => {
  const currentValues = getDateRangeWithEndDateOffset(props.dateRange);
  return (
    <RangePicker
      allowEmpty
      value={currentValues}
      format={DATE_FORMAT.readable}
      onChange={(dates) => {
        const [start, end] = getEndDateManipulatedDateRange(
          dates,
          props.dateRange,
          'day',
        );
        props.onChange([start, end]);
      }}
    />
  );
};

export default SearchDateFilter;
